import axios from "axios";
import { TokenService, ToastService } from "../services";
import { store } from "../store";
import router from "../router";

export const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  // setHeader() {
  //   axios.defaults.headers.common[
  //     "Authorization"
  //   ] = `${TokenService.getToken()}`;
  // },

  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource) {
    return axios.get(resource);
  },

  post(resource, data, config) {
    return axios.post(resource, data, config);
  },

  put(resource, data, config) {
    return axios.put(resource, data, config);
  },

  delete(resource) {
    return axios.delete(resource);
  },
  patch(resource, data, config) {
    return axios.patch(resource, data, config);
  },
  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data);
  }
};





// WEBPACK FOOTER //
// ./src/services/api.service.js